import { render, staticRenderFns } from "./HistoryListSubstituteRow.vue?vue&type=template&id=3a648fd6"
import script from "./HistoryListSubstituteRow.vue?vue&type=script&lang=js"
export * from "./HistoryListSubstituteRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports